<template>
    <div class="novo-formulario">
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons"></div>
        </div>
        <div class="page-container form-columns-fit center">
            <div class="columns is-multiline">
                <div class="column is-2 pb-0">
                    <v-input
                        :id="'codigo'"
                        ref="idformularioerpInput"
                        v-model="formulario.idformularioerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        required
                        :invalid="!formulario.idformularioerp"
                        tooltipLabel="cod-ref"
                    />
                </div>
                <div class="column is-7 pb-0">
                    <v-input
                        :id="'titulo'"
                        v-model="formulario.titulo"
                        :placeholder="'titulo-do-formulario-placeholder'"
                        :maxlength="50"
                        :title="'titulo-do-formulario'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!formulario.titulo"
                        ref="tituloInput"
                        :uppercase="false"
                        :required="true"
                    />
                </div>
                <div class="column is-3 pb-0">
                    <label for="situacao" v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoSelect"
                        :selectOnTab="true"
                        :searchable="false"
                        :options="situacoes"
                        :value="situacao"
                        @input="updateSituacao"
                        :getOptionLabel="getLabel"
                        placeholder="situacao-da-marca-placeholder"
                        class="no-clear"
                    >
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>
                <div class="column is-12">
                    <v-input
                        v-model="formulario.descricao"
                        :id="'descricao'"
                        :placeholder="'descricao-do-formulario-placeholder'"
                        :maxlength="100"
                        :title="'descricao-do-formulario'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!formulario.descricao"
                        ref="descricaoInput"
                        :uppercase="false"
                        :required="true"
                    />
                </div>
            </div>
        </div>
        <div class="grupos">
            <v-draggable :list="formulario.grupoperguntas" handle=".gp-handle">
                <!-- <transition-group> -->
                <div
                    v-for="(gp, i) in formulario.grupoperguntas"
                    :key="gp.idgrupopergunta"
                    class="grupo"
                    :class="{
                        invalid:
                            gp.titulo == undefined || gp.titulo.trim() == '' || !getValidadeGP(gp),
                    }"
                >
                    <div v-if="gp.datahoradel == null" class="grupo-container">
                        <div class="titulo-gp">
                            <div class="titulo-left">
                                <div class="gp-handle">
                                    <svg class="svg-icons column-drag-handle">
                                        <use
                                            :xlink:href="
                                                require('@/assets/img/icons/drag.svg') + '#layer'
                                            "
                                        ></use>
                                    </svg>
                                </div>
                                <label
                                    v-if="editing == i"
                                    for="titulo-gp"
                                    v-text="$t('titulo-do-gruopdeperguntas')"
                                    :class="{
                                        invalid:
                                            gp.titulo == undefined ||
                                            gp.titulo.trim() == '' ||
                                            !getValidadeGP(gp),
                                    }"
                                />
                                <label
                                    v-else
                                    for="titulo-gp"
                                    :class="{
                                        invalid:
                                            gp.titulo == undefined ||
                                            gp.titulo.trim() == '' ||
                                            !getValidadeGP(gp),
                                    }"
                                    v-text="
                                        gp.titulo != undefined && gp.titulo.trim() != ''
                                            ? gp.titulo
                                            : $t('grupopergunta-sem-titulo')
                                    "
                                />
                            </div>
                            <div class="titulo-right">
                                <!-- <button class="edit-button" type="button" @click="editing = i">
                                        {{ $t('editar-grupo-perguntas') }}
                                    </button>
                                    <button class="edit-button" type="button" @click="excluirGPModal(i)">
                                        {{ $t('excluir-grupo-perguntas') }}
                                    </button> -->
                            </div>
                        </div>
                        <div class="titulo-gp-input">
                            <v-input
                                v-if="editing == i"
                                v-model="gp.titulo"
                                title="titulo-do-gruopdeperguntas"
                                msg="msg-campo-obrigatorio"
                                id="titulo-gp"
                                placeholder="titulo-do-gruopdeperguntas-placeholder"
                                :maxlength="255"
                                :invalid="!gp.titulo"
                                :ref="`tituloGPInput-${i}`"
                                :onBlurFunction="() => (editing = false)"
                                :uppercase="false"
                            />
                        </div>
                        <ConfiguraCampos
                            :campos="gp.perguntas"
                            :index="i"
                            :ref="`conf-campos-${i}`"
                        />
                    </div>
                </div>
            </v-draggable>
            <button type="button" class="btn add-campos" @click="addGP()">
                <p>
                    <svg class="svg-icons">
                        <use
                            :xlink:href="require('@/assets/img/icons/shape-plus.svg') + '#layer'"
                        ></use>
                    </svg>
                    {{ $t('novo-grupo-perguntas') }}
                </p>
            </button>
        </div>
    </div>
</template>

<script>
import FormularioService from '@/services/FormularioService';
import ConfiguraCampos from '@/components/promotor/formulario/old/abas/ConfiguraCampos';
import FormularioValidation from '@/services/validations/FormularioValidation';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada.
 */
export default {
    components: {
        ConfiguraCampos,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isSaving: false,
            formulario: {
                idformulario: null,
                idformularioerp: null,
                grupoperguntas: [],
                situacao: 1,
                origem: 0,
            },
            deleteThis: null,
            editable: false,
            enabledDrag: false,
            editing: -1,
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isLoading: false,

            abrev: '',
            contexto: '',
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',

            origemPromotor: 1,
            origemVendas: 2,
        };
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.formulario != null && this.formulario != {}) this.editable = true;

        this.service = new FormularioService(this.$http, this.$router);
        this.validation = new FormularioValidation(this.$root.msgs);

        this.contexto = this.$route.meta.contexto.slice(0, 3);

        if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'cadastros',
                'formulario-consulta'
            );
            this.formulario.origem = this.origemPromotor;
        } else if (this.isVenda) {
            this.abrev = this.$route.meta.contexto.slice(0, 3) + '-';
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'formulario',
                'ven-formulario-consulta'
            );
            this.formulario.origem = this.origemVendas;
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });
        } else {
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'formularios' },
                });
            }
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
            this.$on('update-grupoperguntas', this.updateGrupoperguntas);
        }
    },
    watch: {
        $route() {
            this.formulario = { grupoperguntas: [], situacao: 1 };
            this.situacao = this.situacoes[0];
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        },
        formulario: {
            deep: true,
            handler: function () {
                if (!this.isLoading) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    mounted() {
        this.$refs.tituloInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id, this.contexto)
                .then((body) => {
                    if (body.content) {
                        this.formulario = body.content;
                        this.situacao = this.getSituacao();
                        if (this.$route.name == `${this.abrev}formulario-consulta-duplicate-new`)
                            this.duplicateFormFix();
                    } else {
                        this.$router.push({ name: `${this.abrev}formulario-consulta-new` });
                    }
                })
                .catch((e) => {
                    console.error('[GERAL] Erro ao carregar formulário.', e);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 300);

                    this.$emit('titulo', this.formulario.titulo);

                    this.isLoading = false;
                });
        },
        duplicateFormFix() {
            delete this.formulario.id;
            delete this.formulario.idformulario;
            delete this.formulario.idformularioerp;
            delete this.formulario.titulo;
            delete this.formulario.datahoraalt;
            delete this.formulario.datahorainc;

            this.formulario.grupoperguntas.forEach((gp) => {
                delete gp.datahoraalt;
                delete gp.datahorainc;
                delete gp.idgrupopergunta;

                gp.perguntas.forEach((per) => {
                    delete per.datahoraalt;
                    delete per.datahorainc;
                    delete per.idpergunta;

                    per.gruporespostas.forEach((gr) => {
                        delete gr.datahoraalt;
                        delete gr.datahorainc;
                        delete gr.idgruporesposta;
                        delete gr.id;

                        gr.respostas.forEach((re) => {
                            delete re.datahoraalt;
                            delete re.datahorainc;
                            delete re.idresposta;
                        });
                    });
                });
            });
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.formulario.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.formulario.situacao);
        },
        addGP() {
            this.editing = this.formulario.grupoperguntas.length;
            this.formulario.grupoperguntas.push({});
        },
        mapToSave() {
            this.formulario = this.mapToSavePreserveCase(this.formulario);
            this.formulario.grupoperguntas.forEach((gp) => {
                this.mapToSavePreserveCase(gp);
                if (gp.perguntas) {
                    gp.perguntas.forEach((p) => {
                        this.mapToSavePreserveCase(p);
                        if (p.gruporepostas) {
                            p.gruporepostas.forEach((gr) => {
                                this.mapToSavePreserveCase(gr);
                                gr.respostas.forEach((r) => this.mapToSavePreserveCase(r));
                            });
                        }
                    });
                }
            });
        },
        saveForm() {
            if (this.$refs.tituloInput != undefined) this.$refs.tituloInput.focusedOut = true;
            this.formulario.grupoperguntas.forEach((gp, i) => {
                if (this.$refs[`tituloGPInput-${i}`] != undefined) {
                    if (this.$refs[`tituloGPInput-${i}`].length > 0) {
                        this.$refs[`tituloGPInput-${i}`][0].focusedOut = true;
                    }
                }
            });
            this.mapToSave();
            if (this.validation.validate(this.formulario, this.$refs)) {
                this.isSaving = true;
                this.formulario.grupoperguntas.forEach((g, i) => {
                    g.ordem = i;
                    if (g.perguntas) {
                        g.perguntas.forEach((p, idx) => {
                            p.ordem = idx;
                        });
                    }
                });
                this.service
                    .save(this.formulario, this.contexto)
                    .then((body) => {
                        if (body.status != 200) {
                            if (body.message) {
                                if (body.message == 'msg-codigo-duplicado-n') {
                                    this.$root.showMessage(
                                        'alert',
                                        this.$t(body.message, { n: this.formulario.idformularioerp }),
                                        true,
                                        false
                                    );
                                } else {
                                    this.$root.showMessage('alert', body.message, true);
                                }
                            } else {
                                console.error(`${body.status}: ${body.message}`);
                                let msg =
                                    body.message != ''
                                        ? body.message
                                        : 'msg-problema-realizar-acao';
                                this.$root.showMessage('error', msg);
                                this.isSaving = false;
                            }
                        } else {
                            // Mudar para alerta padrão, quando o mesmo for criado
                            let msg = 'msg-formulario-cadastrado';
                            if (this.formulario.id) msg = 'msg-formulario-editado';
                            this.formulario = body.content;
                            this.$root.showMessage('success', msg);

                            setTimeout(() => {
                                this.$emit('isChanged', false);
                                this.$emit('idFormulario', this.formulario.idformulario);
                                this.$emit('redirect');
                            }, 500);
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar formulário.', e);
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                        this.isSaving = false;
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
            }
        },
        excluirGP() {
            if (this.formulario.grupoperguntas[this.deleteThis].idgrupopergunta) {
                if (this.formulario.grupoperguntas[this.deleteThis].titulo == '')
                    this.formulario.grupoperguntas[this.deleteThis].titulo = 'removido';
                this.formulario.grupoperguntas[this.deleteThis].perguntas.forEach((p) => {
                    if (p.descricao == '') p.descricao = 'removido';
                });
                this.formulario.grupoperguntas[this.deleteThis].datahoradel = new Date();
                let novoGP = JSON.parse(
                    JSON.stringify(this.formulario.grupoperguntas[this.deleteThis])
                );
                // Tem que fazer isso para o componente ConfigurarCampos poder detectar a mudança da datahoradel
                this.formulario.grupoperguntas.splice(
                    this.deleteThis,
                    1,
                    Object.assign({}, novoGP)
                );
            } else {
                this.formulario.grupoperguntas.splice(this.deleteThis, 1);
            }
            this.deleteThis = null;
        },
        excluirGPModal(i) {
            this.deleteThis = i;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', 
                    { n: this.formulario.grupoperguntas[i].titulo
                        ? this.formulario.grupoperguntas[i].titulo
                        : this.$t('vazio') }
                ),
                onConfirm: this.excluirGP,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.deleteThis = null;
        },
        updateGrupoperguntas(ps, i) {
            this.$set(this.formulario.grupoperguntas[i], 'perguntas', ps);
        },
        getValidadeGP(gp) {
            let qtdPerg = 0;
            let valid = true;

            if (gp.perguntas != undefined && gp.perguntas.length > 0) {
                gp.perguntas.forEach((p) => {
                    if (p.datahoradel == null || p.datahoradel == undefined) {
                        qtdPerg++;

                        if (
                            p.descricao == undefined ||
                            p.descricao == null ||
                            p.descricao.trim() == ''
                        ) {
                            valid = false;
                        }

                        p.gruporespostas.forEach((gr) => {
                            if (['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].indexOf(gr.tipo) > -1) {
                                if (gr.respostas.length == 0) {
                                    valid = false;
                                } else {
                                    gr.respostas.forEach((r) => {
                                        if (
                                            r.descricao == undefined ||
                                            r.descricao == null ||
                                            r.descricao.trim() == ''
                                        ) {
                                            valid = false;
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
            } else {
                return false;
            }

            return qtdPerg > 0 && valid;
        },
        editToDuplicate() {
            setTimeout(() => {
                this.$emit('isChanged', false);
            }, 500);

            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}formulario-consulta-duplicate-new`,
                    params: { id: this.$route.params.id },
                });
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';

.duplicate-form {
    min-width: 50px !important;
    padding-top: 10px;
    padding-bottom: 9px;
}

.novo-formulario {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    height: 100%;
    padding-top: 0;

    > h1 {
        padding-top: 20px;
        margin-bottom: 40px;
    }
}

.grupos {
    position: relative;
    height: auto;
    width: 100%;
    margin-top: 10px;
    margin-left: auto;
    padding-bottom: 60px;
    margin-bottom: 20px;

    .grupo {
        width: 100%;
        background-color: #fefefe;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 15px;
        padding: 15px;
        border: solid 1px $table-border;
        border-radius: 3px;

        .grupo-container {
            width: 100%;
        }

        .gp-handle {
            display: inline-flex;
            margin-right: 10px;

            svg {
                transform: rotate(90deg);
            }
        }

        &.invalid {
            border: 1px solid $red-alert;
        }
    }

    .titulo-gp {
        display: flex;
        width: 100%;
        text-transform: uppercase;

        .titulo-left,
        .titulo-right {
            display: flex;
            width: 50%;
        }

        .titulo-right {
            justify-content: flex-end;
        }

        label {
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            font-size: 17px;
            color: $sovis-black;

            &.invalid {
                color: $red-alert;
                font-weight: 600;
            }
        }

        .edit-button {
            box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
            width: 50%;
            color: $darker-gray-color;
            font-size: 12px;
            text-align: center;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            @include exclude-button();
            padding: 5px 15px;

            &:not(:first-child) {
                margin-left: 20px;
            }
        }
    }

    .titulo-gp-input {
        display: flex;
        width: 100%;

        .verified-input {
            margin-top: 10px;
            width: 100%;
        }
    }

    .add-campos {
        @include exclude-button();
        position: absolute;
        bottom: 10px;
        right: 2.5%;
        border-radius: 10px;
        padding: 10px 80px;
        text-align: center;
        box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
        border-radius: 6px;

        > p {
            display: flex;
            align-items: center;
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: $darker-gray-color;

            > svg {
                margin-right: 10px;
                fill: $light-gray-color;
            }
        }
    }
}

.novo-formulario .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 15px;
}

.form-buttons {
    right: 0px;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}
</style>
